import { useEffect, useContext, useRef } from 'react';

import { useId } from '../../../../../core/hooks/useId.js';
import { CanvasContext } from '../CanvasContext.js';
import { CanvasDraw, CanvasShape } from '../types/canvas-shape.js';

/**
 * Hook to attach and handle a canvas shape.
 * @param shape - Name of the shape to attach.
 * @param draw - Function to draw the shape.
 */
export function useCanvas(shape: string, draw: CanvasDraw) {
  const canvasContext = useContext(CanvasContext);
  const id = useId();

  const ref = useRef<CanvasShape>({
    id,
    draw,
  });

  useEffect(() => {
    ref.current.draw = (ctx) => draw(ctx, id);
    canvasContext.shapeRefs.set(id, ref);

    return () => {
      canvasContext.shapeRefs.delete(id);
    };
  });
}
